import { Button, ButtonProps, Typography } from "@timeedit/ui-components";
import { ConfigProvider } from "@timeedit/ui-components/antd";
import cn from "classnames";
import { ReactNode } from "react";
import {
  colorInfo,
  colorInfoActive,
  colorInfoHover,
} from "@timeedit/ui-components/theme/variables";
import "./buttonWithDescription.scss";

const waitlistButtonTheme = {
  components: {
    Button: {
      defaultColor: colorInfo,
      defaultBorderColor: colorInfo,
      defaultHoverColor: colorInfoHover,
      defaultHoverBorderColor: colorInfoHover,
      defaultActiveColor: colorInfoActive,
      defaultActiveBorderColor: colorInfoActive,
    },
  },
};

interface ButtonWithDescriptionProps extends ButtonProps {
  isWaitlist?: boolean;
  description?: ReactNode;
  label: string;
}

export function ButtonWithDescription({
  label,
  description,
  isWaitlist = false,
  ...buttonProps
}: ButtonWithDescriptionProps): React.JSX.Element {
  const by = buttonProps["aria-labelledby"];
  const id = `label-${by?.replaceAll(" ", "")}`;
  const labelledby = `${id} ${by}`;
  return (
    <>
      <div>
        <ConfigProvider theme={isWaitlist ? waitlistButtonTheme : undefined}>
          <Button
            {...buttonProps}
            aria-labelledby={labelledby}
            disabled={
              buttonProps["aria-disabled"] ? false : buttonProps.disabled
            }
            className={cn("tw:w-[112px] tw:p-0", buttonProps.className)}
          >
            {buttonProps.children}
          </Button>
        </ConfigProvider>
      </div>

      <Typography.Text>{description}</Typography.Text>
      {by && (
        <div className="button-with-description__label" id={id}>
          {label}
        </div>
      )}
    </>
  );
}
